/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { AssetManagementReplacementHistoryListResponse } from '../../models/asset-management-replacement-history-list-response';
import { BaseResponse } from '../../models/base-response';

export interface AssetManagementControllerFindAllAssetManagementReplacementHistory$Params {
  id: number;

/**
 * Sends 0 to remove limit
 */
  limit: number;
  skip: number;
  related_user_id?: number;
  created_on_from?: string;
  created_on_to?: string;
  order_by?: string;
  order_direction?: string;
}

export function assetManagementControllerFindAllAssetManagementReplacementHistory(http: HttpClient, rootUrl: string, params: AssetManagementControllerFindAllAssetManagementReplacementHistory$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: AssetManagementReplacementHistoryListResponse;
}>> {
  const rb = new RequestBuilder(rootUrl, assetManagementControllerFindAllAssetManagementReplacementHistory.PATH, 'get');
  if (params) {
    rb.path('id', params.id, {});
    rb.query('limit', params.limit, {});
    rb.query('skip', params.skip, {});
    rb.query('related_user_id', params.related_user_id, {});
    rb.query('created_on_from', params.created_on_from, {});
    rb.query('created_on_to', params.created_on_to, {});
    rb.query('order_by', params.order_by, {});
    rb.query('order_direction', params.order_direction, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<BaseResponse & {
      'data'?: AssetManagementReplacementHistoryListResponse;
      }>;
    })
  );
}

assetManagementControllerFindAllAssetManagementReplacementHistory.PATH = '/asset-management/{id}/replacement-history';
